const melodiExtensionId = 'ccelonfdloippobglklpjafknhakpjmc';

export const checkExtensionActive = (): Promise<boolean> => {
  return new Promise((resolve) => {
    try {
      //@ts-ignore
      if (typeof chrome.runtime === 'undefined') {
        resolve(false);
        return;
      }
      
      //@ts-ignore
      chrome.runtime.sendMessage(melodiExtensionId, { action: "isExtensionActive" }, (response) => {
        //@ts-ignore
        if (chrome.runtime.lastError || !response) {
          resolve(false); // Extension is not active
        } else {
          resolve(response.active); // Extension is active
        }
      });
    } catch (error) {
      console.error('Error checking extension status:', error);
      resolve(false); // Assume extension is not active on error
    }
  });
}

export const storeToExtension = async (type: string, data: any): Promise<boolean> => {
  const extensionStoreData = {
    action: "storeData",
    type: type,
    data: data,
  };

  if (await checkExtensionActive()) {
    console.debug("Extension is active!");
    return await sendExtensionMessage(extensionStoreData);
  } else {
    console.debug("Extension is not detected.");
    return false;
  }
}

const sendExtensionMessage = (message: any): Promise<any> => {
  return new Promise((resolve, reject) => {
    try {
      console.log('Sending message to background script: ', message);
      //@ts-ignore
      chrome.runtime.sendMessage(melodiExtensionId, message, (response) => {
        //@ts-ignore
        if (chrome.runtime.lastError) {
          //@ts-ignore
          console.error('Error sending message to background script: ', chrome.runtime.lastError);
          resolve(false); // error
          return;
        }

        if (!response) {
          console.error('No response from background script');
          resolve(false); // error
        } else {
          console.debug('Response from background script: ', response);
          resolve(!!response.ok); // successful response
        }
      });
    } catch (error) {
      reject(error);
    }
  });
}
